import { render, staticRenderFns } from "./DataHome.vue?vue&type=template&id=365dd22c&scoped=true"
import script from "./DataHome.vue?vue&type=script&lang=js"
export * from "./DataHome.vue?vue&type=script&lang=js"
import style0 from "./DataHome.vue?vue&type=style&index=0&id=365dd22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365dd22c",
  null
  
)

export default component.exports